export default __webpack_public_path__ + "static/media/SAS0210.34I-36128_-21191_0.32cc2473.jpg";